(function () {
  'use strict';

  const money = (cents) => `R${((Number(cents) || 0) / 100).toFixed(2)}`;
  const esc = (str) => String(str == null ? '' : str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');

  let loaderDismissed = false;
  window.dismissLoader = function dismissLoader() {
    if (loaderDismissed) return;
    loaderDismissed = true;
    const loader = document.getElementById('loader');
    if (loader) {
      loader.style.opacity = '0';
      setTimeout(() => { loader.style.visibility = 'hidden'; }, 600);
    }
  };

  window.toggleMenu = function toggleMenu() {
    const menu = document.getElementById('menu');
    if (menu) menu.classList.toggle('active');
  };

  window.closeMenuOnWrapper = function closeMenuOnWrapper() {
    const menu = document.getElementById('menu');
    if (menu) menu.classList.remove('active');
    document.querySelectorAll('.nav-item').forEach((item) => item.classList.remove('open'));
  };

  window.handleMobileDropdown = function handleMobileDropdown(event, element) {
    if (event) event.preventDefault();
    if (element && element.parentElement) element.parentElement.classList.toggle('open');
  };

  window.toggleFilterDrawer = function toggleFilterDrawer() {
    const drawer = document.getElementById('filterDrawer');
    const overlay = document.getElementById('drawerOverlay');
    if (drawer) drawer.classList.toggle('active');
    if (overlay) overlay.classList.toggle('active');
  };

  window.switchCategory = function switchCategory(category) {
    const isTea = category === 'tea';
    document.querySelectorAll('.gallery-card.tea').forEach((card) => { card.style.display = isTea ? 'flex' : 'none'; });
    document.querySelectorAll('.gallery-card.cel').forEach((card) => { card.style.display = isTea ? 'none' : 'flex'; });
    const teaBtn = document.getElementById('tea-btn');
    const celBtn = document.getElementById('cel-btn');
    if (teaBtn) teaBtn.classList.toggle('active', isTea);
    if (celBtn) celBtn.classList.toggle('active', !isTea);
  };

  window.checkStoreStatus = function checkStoreStatus() {
    const statusBadge = document.getElementById('storeStatus');
    if (!statusBadge) return;
    const now = new Date();
    const currentDay = now.getDay();
    const currentHour = now.getHours();
    const weeklySchedule = {
      2: { open: 9, close: 17, closeStr: '5:00 PM', nextStr: 'Tomorrow at 9:00 AM' },
      3: { open: 9, close: 17, closeStr: '5:00 PM', nextStr: 'Tomorrow at 9:00 AM' },
      4: { open: 9, close: 17, closeStr: '5:00 PM', nextStr: 'Tomorrow at 9:00 AM' },
      5: { open: 9, close: 19, closeStr: '7:00 PM', nextStr: 'Tomorrow at 9:00 AM' },
      6: { open: 9, close: 17, closeStr: '5:00 PM', nextStr: 'Tuesday at 9:00 AM' }
    };
    let isOpen = false;
    let message = '';
    if (currentDay === 0 || currentDay === 1) {
      message = '🔴 Physical Store Closed — Opens Tuesday at 9:00 AM';
    } else {
      const todayHours = weeklySchedule[currentDay];
      if (currentHour >= todayHours.open && currentHour < todayHours.close) {
        isOpen = true;
        message = `🟢 Physical Store Open Now — Closes at ${todayHours.closeStr}`;
      } else if (currentHour < todayHours.open) {
        message = '🔴 Physical Store Closed — Opens Today at 9:00 AM';
      } else {
        message = `🔴 Physical Store Closed — Opens ${todayHours.nextStr}`;
      }
    }
    statusBadge.className = isOpen ? 'status-badge open' : 'status-badge closed';
    statusBadge.innerHTML = message;
  };

  function setCartBadge(count) {
    document.querySelectorAll('#cartBadge, [data-cart-count]').forEach((badge) => {
      badge.textContent = count || 0;
      badge.style.display = 'inline-block';
    });
  }

  window.toggleCart = function toggleCart(force) {
    const popup = document.getElementById('cartPopup');
    const overlay = document.getElementById('cartOverlay');
    if (!popup || !overlay) return;
    const shouldOpen = force === true ? true : force === false ? false : !popup.classList.contains('active');
    popup.classList.toggle('active', shouldOpen);
    overlay.classList.toggle('active', shouldOpen);
    popup.setAttribute('aria-hidden', shouldOpen ? 'false' : 'true');
    if (shouldOpen) window.renderCartDrawer();
  };

  async function getCart() {
    const res = await fetch('/cart.js', { credentials: 'same-origin' });
    if (!res.ok) throw new Error('Unable to load cart.');
    return res.json();
  }

  function renderCart(cart) {
    const container = document.getElementById('cartItemsContainer');
    const total = document.getElementById('cartTotalPrice');
    if (!container) return;
    setCartBadge(cart.item_count || 0);
    if (total) total.textContent = money(cart.total_price || 0);
    if (!cart.items || cart.items.length === 0) {
      container.innerHTML = '<p class="cart-empty-msg">Your basket is currently empty.</p>';
      return;
    }
    container.innerHTML = cart.items.map((item, index) => {
      const line = index + 1;
      const img = item.image
        ? `<img class="cart-row-img" src="${esc(item.image)}" alt="${esc(item.product_title)}">`
        : '<div class="cart-row-img">🍰</div>';
      const variant = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
      return `
        <div class="cart-row" data-line="${line}">
          <div class="cart-row-left">
            ${img}
            <div>
              <div class="cart-item-title">${esc(item.product_title)}</div>
              <div class="cart-item-meta">${esc(variant)}</div>
            </div>
          </div>
          <div class="cart-row-right">
            <div class="qty-controls">
              <button class="qty-btn" type="button" onclick="changeCartQty(${line}, ${Math.max(0, item.quantity - 1)})">-</button>
              <span>${item.quantity}</span>
              <button class="qty-btn" type="button" onclick="changeCartQty(${line}, ${item.quantity + 1})">+</button>
            </div>
            <div class="cart-item-price">${money(item.final_line_price)}</div>
            <button class="remove-cart-item" type="button" onclick="changeCartQty(${line}, 0)" aria-label="Remove ${esc(item.product_title)}">🗑️</button>
          </div>
        </div>`;
    }).join('');
  }

  window.renderCartDrawer = async function renderCartDrawer() {
    try {
      const cart = await getCart();
      renderCart(cart);
    } catch (err) {
      console.warn(err);
    }
  };

  window.changeCartQty = async function changeCartQty(line, quantity) {
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ line, quantity })
      });
      const cart = await res.json();
      renderCart(cart);
    } catch (err) {
      alert('Could not update your basket. Please try again.');
    }
  };

  window.checkoutWithPayFast = function checkoutWithPayFast() {
    window.location.href = '/checkout';
  };

  function bindAjaxProductForms() {
    document.addEventListener('submit', async (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      const action = form.getAttribute('action') || '';
      if (!action.includes('/cart/add')) return;
      event.preventDefault();
      const submit = form.querySelector('[type="submit"]');
      const originalText = submit ? submit.textContent : '';
      if (submit) {
        submit.disabled = true;
        submit.textContent = 'Adding...';
      }
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          body: new FormData(form),
          credentials: 'same-origin',
          headers: { 'Accept': 'application/json' }
        });
        if (!res.ok) {
          const data = await res.json().catch(() => ({}));
          throw new Error(data.description || 'Unable to add item.');
        }
        await window.renderCartDrawer();
        window.toggleCart(true);
      } catch (err) {
        alert(err.message || 'Could not add to basket.');
      } finally {
        if (submit) {
          submit.disabled = false;
          submit.textContent = originalText;
        }
      }
    });
  }

  window.cakeConfig = {
    tiers: 1,
    customTiers: '',
    theme: 'none',
    customTheme: '',
    frostingColor: '#f7ede2',
    frostingName: 'Vanilla',
    board: 'normal',
    customBoard: '',
    toppings: { drip: false, macarons: false, sprinkles: false, berries: false, flowers: false, gold: false },
    customToppings: '',
    occasion: 'Birthday',
    customOccasion: '',
    deliveryDate: '',
    route: 'pickup',
    customRoute: ''
  };
  let currentBuilderStep = 1;

  window.updateStepUI = function updateStepUI() {
    document.querySelectorAll('.builder-step').forEach((step) => step.classList.remove('active'));
    document.querySelectorAll('.step-tab').forEach((tab) => tab.classList.remove('active'));
    const targetStep = document.getElementById(`builderStep${currentBuilderStep}`);
    const targetTab = document.getElementById(`tabStep${currentBuilderStep}`);
    if (targetStep) targetStep.classList.add('active');
    if (targetTab) targetTab.classList.add('active');
    const quoteContainer = document.getElementById('quoteActionsContainer');
    if (quoteContainer) quoteContainer.style.display = (currentBuilderStep === 4) ? 'block' : 'none';
  };
  window.nextStep = function nextStep() { if (currentBuilderStep < 4) { currentBuilderStep++; window.updateStepUI(); } };
  window.prevStep = function prevStep() { if (currentBuilderStep > 1) { currentBuilderStep--; window.updateStepUI(); } };
  window.goToStep = function goToStep(stepNum) { currentBuilderStep = stepNum; window.updateStepUI(); };

  window.updateTierCount = function updateTierCount(tierNum, btnElement) {
    window.cakeConfig.tiers = tierNum;
    if (btnElement) {
      btnElement.parentElement.querySelectorAll('.config-btn').forEach((btn) => btn.classList.remove('active'));
      btnElement.classList.add('active');
    }
    const otherInput = document.getElementById('otherTiersInput');
    if (otherInput) otherInput.style.display = tierNum === 'Other' ? 'block' : 'none';
    window.updateFlavorFields(tierNum === 'Other' ? 3 : tierNum);
    window.syncToppingGraphics();
  };

  window.updateFlavorFields = function updateFlavorFields(tierCount) {
    const container = document.getElementById('tierFlavorFieldsContainer');
    if (!container) return;
    container.innerHTML = '';
    const count = parseInt(tierCount, 10) || 3;
    for (let i = 1; i <= count; i++) {
      container.insertAdjacentHTML('beforeend', `
        <div style="margin-bottom: 10px;">
          <label style="font-size:0.8rem; font-weight:500; display:block; margin-bottom:4px;">Tier ${i} Flavor Choice:</label>
          <select id="tierFlavor_${i}" class="modal-select">
            <option value="Vanilla Chiffon Fluff">Vanilla Chiffon Fluff</option>
            <option value="Chocolate Mud Fudge">Chocolate Mud Fudge</option>
            <option value="Classic Red Velvet Crumble">Classic Red Velvet Crumble</option>
            <option value="Spiced Zesty Carrot Walnut">Spiced Zesty Carrot Walnut</option>
          </select>
        </div>`);
    }
  };

  window.updateCakeTheme = function updateCakeTheme(themeKey, btnElement) {
    window.cakeConfig.theme = themeKey;
    if (btnElement) {
      btnElement.parentElement.querySelectorAll('.config-btn').forEach((btn) => btn.classList.remove('active'));
      btnElement.classList.add('active');
    }
    const otherInput = document.getElementById('otherThemeInput');
    if (otherInput) otherInput.style.display = themeKey === 'Other' ? 'block' : 'none';
    const characterTopper = document.getElementById('gfxToppingCharacter');
    const frostingGroup = document.getElementById('frostingFlavorGroup');
    if (frostingGroup) { frostingGroup.style.opacity = '1'; frostingGroup.style.pointerEvents = 'auto'; }
    if (themeKey === 'spiderman') {
      window.cakeConfig.frostingColor = '#e63946'; window.cakeConfig.frostingName = 'Spiderman Theme Palette';
      if (characterTopper) characterTopper.innerText = '🕷️';
    } else if (themeKey === 'batman') {
      window.cakeConfig.frostingColor = '#1a1a1a'; window.cakeConfig.frostingName = 'Batman Gotham Dark Palette';
      if (characterTopper) characterTopper.innerText = '🦇';
    } else if (themeKey === 'tmnt') {
      window.cakeConfig.frostingColor = '#70e000'; window.cakeConfig.frostingName = 'Ninja Turtles Green Palette';
      if (characterTopper) characterTopper.innerText = '🐢';
    } else {
      window.cakeConfig.frostingColor = '#f7ede2'; window.cakeConfig.frostingName = 'Vanilla Standard';
      if (characterTopper) characterTopper.innerText = '✨';
      const activeSwatch = document.querySelector('.swatch-btn.active');
      if (activeSwatch) activeSwatch.click();
    }
    if (themeKey !== 'none' && themeKey !== 'Other' && frostingGroup) {
      frostingGroup.style.opacity = '0.4'; frostingGroup.style.pointerEvents = 'none';
    }
    window.syncToppingGraphics();
  };

  window.updateCakeColor = function updateCakeColor(colorHex, flavorLabel, swatchElement) {
    window.cakeConfig.frostingColor = colorHex;
    window.cakeConfig.frostingName = flavorLabel;
    if (swatchElement && swatchElement.parentElement) {
      swatchElement.parentElement.querySelectorAll('.swatch-btn').forEach((sw) => sw.classList.remove('active'));
      swatchElement.classList.add('active');
    }
    for (let i = 1; i <= 5; i++) {
      const layer = document.getElementById(`layer_${i}`);
      if (layer && layer.classList.contains('active-tier')) layer.style.backgroundColor = colorHex;
    }
  };

  window.updateCakeBoard = function updateCakeBoard(boardType, btnElement) {
    window.cakeConfig.board = boardType;
    if (btnElement) {
      btnElement.parentElement.querySelectorAll('.config-btn').forEach((btn) => btn.classList.remove('active'));
      btnElement.classList.add('active');
    }
    const otherInput = document.getElementById('otherBoardInput');
    if (otherInput) otherInput.style.display = boardType === 'Other' ? 'block' : 'none';
    const stand = document.getElementById('baseCakeStand');
    if (!stand) return;
    if (boardType === 'silver') stand.style.background = 'linear-gradient(90deg, #dcdcdc, #ffffff, #b8b8b8)';
    else if (boardType === 'marble') stand.style.background = 'linear-gradient(45deg, #eaeaea 25%, #f5f5f5 25%, #f5f5f5 50%)';
    else stand.style.background = '#e0d9d0';
  };

  window.toggleCakeTopping = function toggleCakeTopping(toppingKey, btnElement) {
    window.cakeConfig.toppings[toppingKey] = !window.cakeConfig.toppings[toppingKey];
    if (btnElement) btnElement.classList.toggle('active');
    window.syncToppingGraphics();
  };

  window.toggleOtherOccasion = function toggleOtherOccasion(selectElement) {
    window.cakeConfig.occasion = selectElement.value;
    const otherInput = document.getElementById('otherOccasionInput');
    if (otherInput) otherInput.style.display = selectElement.value === 'Other Celebration' ? 'block' : 'none';
  };

  window.updateLogisticsRoute = function updateLogisticsRoute(routeType, btnElement) {
    window.cakeConfig.route = routeType;
    if (btnElement) {
      btnElement.parentElement.querySelectorAll('.config-btn').forEach((btn) => btn.classList.remove('active'));
      btnElement.classList.add('active');
    }
    const otherInput = document.getElementById('otherRouteInput');
    if (otherInput) otherInput.style.display = routeType === 'Other' ? 'block' : 'none';
  };

  window.syncToppingGraphics = function syncToppingGraphics() {
    const tierCount = parseInt(window.cakeConfig.tiers, 10) || 3;
    for (let i = 1; i <= 5; i++) {
      const layer = document.getElementById(`layer_${i}`);
      if (layer) {
        if (i <= tierCount) {
          layer.classList.add('active-tier');
          layer.style.backgroundColor = window.cakeConfig.frostingColor;
          const drip = layer.querySelector('.chocolate-drip');
          const sprinkles = layer.querySelector('.sprinkles-overlay');
          const gold = layer.querySelector('.topping-gold-overlay');
          if (drip) drip.style.display = window.cakeConfig.toppings.drip ? 'block' : 'none';
          if (sprinkles) sprinkles.style.display = window.cakeConfig.toppings.sprinkles ? 'block' : 'none';
          if (gold) gold.style.display = window.cakeConfig.toppings.gold ? 'block' : 'none';
        } else {
          layer.classList.remove('active-tier');
        }
      }
    }
    const topperHeightMap = { 1: 116, 2: 181, 3: 241, 4: 296, 5: 341 };
    const topPos = topperHeightMap[tierCount] || 241;
    const characterTopper = document.getElementById('gfxToppingCharacter');
    if (characterTopper) {
      characterTopper.style.bottom = `${topPos}px`;
      characterTopper.className = (window.cakeConfig.theme !== 'none' && window.cakeConfig.theme !== 'Other') ? 'topping-graphic topping-character active-topping' : 'topping-graphic topping-character';
    }
    const berries = document.getElementById('gfxToppingBerries');
    if (berries) { berries.style.bottom = `${topPos}px`; berries.className = window.cakeConfig.toppings.berries ? 'topping-graphic active-topping' : 'topping-graphic'; }
    const flowers = document.getElementById('gfxToppingFlowers');
    if (flowers) { flowers.style.bottom = `${topPos - 25}px`; flowers.className = window.cakeConfig.toppings.flowers ? 'topping-graphic active-topping' : 'topping-graphic'; }
    const macarons = document.getElementById('gfxMacarons');
    if (macarons) { macarons.style.bottom = `${topPos}px`; macarons.style.display = window.cakeConfig.toppings.macarons ? 'block' : 'none'; }
    const emblem = document.getElementById('gfxEmblem');
    if (emblem) {
      if (window.cakeConfig.theme === 'tmnt') { emblem.innerText = 'TMNT'; emblem.style.display = 'block'; }
      else if (window.cakeConfig.theme === 'spiderman') { emblem.innerText = '🕷️'; emblem.style.display = 'block'; }
      else if (window.cakeConfig.theme === 'batman') { emblem.innerText = '🦇'; emblem.style.display = 'block'; }
      else { emblem.style.display = 'none'; }
    }
  };

  window.buildCakeQuoteMessage = function buildCakeQuoteMessage() {
    const cfg = window.cakeConfig;
    const tiersStr = cfg.tiers === 'Other' ? `Other: (${cfg.customTiers || 'Unspecified'})` : `${cfg.tiers} Tier(s)`;
    const themeStr = cfg.theme === 'Other' ? `Other Theme: (${cfg.customTheme || 'Unspecified'})` : String(cfg.theme).toUpperCase();
    const flavorsList = [];
    const fieldCount = parseInt(cfg.tiers, 10) || 3;
    for (let i = 1; i <= fieldCount; i++) {
      const el = document.getElementById(`tierFlavor_${i}`);
      if (el) flavorsList.push(`Tier ${i}: ${el.value}`);
    }
    const boardStr = cfg.board === 'Other' ? `Other Board: (${cfg.customBoard || 'Unspecified'})` : cfg.board;
    const accentsArr = Object.keys(cfg.toppings).filter((key) => cfg.toppings[key]);
    if (cfg.customToppings) accentsArr.push(`Custom Addons: ${cfg.customToppings}`);
    const occasionStr = cfg.occasion === 'Other Celebration' ? `Other Celebration: (${cfg.customOccasion || 'Unspecified'})` : cfg.occasion;
    const msgInput = document.getElementById('cakeMessageInput');
    const messageStr = msgInput && msgInput.value.trim() ? msgInput.value.trim() : 'None';
    const dateStr = cfg.deliveryDate || 'Unspecified';
    const routeStr = cfg.route === 'Other' ? `Other Route: (${cfg.customRoute || 'Unspecified'})` : cfg.route;
    return `*Khutjo Cakes Custom Design Quote*%0A%0A` +
      `*Structural Setup:* ${tiersStr}%0A` +
      `*Theme Focus:* ${themeStr}%0A` +
      `*Flavor Layout:* ${flavorsList.join(', ')}%0A` +
      `*Frosting Palette Finish:* ${cfg.frostingName}%0A` +
      `*Foundation Base:* ${boardStr}%0A` +
      `*Accents Decor Selected:* ${accentsArr.length ? accentsArr.join(', ') : 'None'}%0A` +
      `*Event Occasion:* ${occasionStr}%0A` +
      `*Message Text on Cake:* ${messageStr}%0A` +
      `*Arrangement Target Date:* ${dateStr}%0A` +
      `*Distribution Fulfillment Route:* ${routeStr}`;
  };

  window.sendCakeQuoteToWhatsApp = function sendCakeQuoteToWhatsApp() {
    window.open(`https://wa.me/27735632546?text=${window.buildCakeQuoteMessage()}`, '_blank');
  };

  window.sendCakeQuoteToEmail = function sendCakeQuoteToEmail() {
    const body = window.buildCakeQuoteMessage().replace(/%0A/g, '\r\n').replace(/\*/g, '');
    window.location.href = `mailto:khutjoyb@gmail.com?subject=Custom Cake Design Quote Request&body=${encodeURIComponent(body)}`;
  };

  function initRevealAnimations() {
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('.reveal').forEach((el) => el.classList.add('visible'));
      return;
    }
    const revealObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });
    document.querySelectorAll('.reveal').forEach((el) => revealObserver.observe(el));
  }

  function initImages() {
    document.querySelectorAll('.product-card img').forEach((img) => {
      const mark = () => img.classList.add('img-loaded');
      if (img.complete) mark(); else img.addEventListener('load', mark, { once: true });
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    window.checkStoreStatus();
    initRevealAnimations();
    bindAjaxProductForms();
    initImages();
    window.renderCartDrawer();
    if (document.getElementById('tierFlavorFieldsContainer')) {
      window.updateTierCount(1, null);
      window.updateStepUI();
    }
    if (document.readyState === 'complete') window.dismissLoader();
    else window.addEventListener('load', window.dismissLoader);
    setTimeout(window.dismissLoader, 2500);
  });
})();
